import React from 'react';

const RecentActivityCard = ({ activities }) => {
  if (!activities || activities.length === 0) {
    return (
      <div className="gamification-card">
        <div className="card-header">
          <h3 className="card-title">
            <i className="las la-history"></i>
            Atividade Recente
          </h3>
        </div>
        <div style={{ 
          textAlign: 'center', 
          padding: '2rem', 
          color: 'var(--text-muted)'
        }}>
          <i className="las la-inbox" style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.5 }}></i>
          <p>Nenhuma atividade recente</p>
          <p style={{ fontSize: '0.9rem', marginBottom: 0 }}>
            Complete treinamentos ou crie agentes para ver seu progresso aqui!
          </p>
        </div>
      </div>
    );
  }

  const getActivityIcon = (type) => {
    switch (type) {
      case 'xp_earned': return 'las la-plus-circle';
      case 'achievement_unlocked': return 'las la-trophy';
      case 'level_up': return 'las la-arrow-up';
      default: return 'las la-star';
    }
  };

  const getActivityClass = (type) => {
    switch (type) {
      case 'xp_earned': return 'activity-xp';
      case 'achievement_unlocked': return 'activity-achievement';
      case 'level_up': return 'activity-level';
      default: return 'activity-xp';
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Agora mesmo';
    if (diffInMinutes < 60) return `${diffInMinutes}min atrás`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h atrás`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `${diffInDays}d atrás`;
    
    return date.toLocaleDateString('pt-BR', { 
      day: '2-digit', 
      month: '2-digit',
      year: diffInDays > 365 ? 'numeric' : undefined
    });
  };

  const getModuleIcon = (module) => {
    switch (module) {
      case 'training': return 'las la-play-circle';
      case 'agent': return 'las la-robot';
      case 'marketplace': return 'las la-store';
      case 'workshop': return 'las la-chalkboard-teacher';
      default: return 'las la-star';
    }
  };

  const getModuleName = (module) => {
    switch (module) {
      case 'training': return 'Treinamentos';
      case 'agent': return 'Agentes';
      case 'marketplace': return 'Marketplace';
      case 'workshop': return 'Workshops';
      default: return 'Sistema';
    }
  };

  return (
    <div className="gamification-card">
      <div className="card-header">
        <h3 className="card-title">
          <i className="las la-history"></i>
          Atividade Recente
        </h3>
        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
          Últimas {activities.length} atividades
        </div>
      </div>

      <div className="activity-list">
        {activities.map((activity, index) => (
          <div 
            key={index} 
            className={`activity-item animate-in`}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className={`activity-icon ${getActivityClass(activity.type)}`}>
              <i className={getActivityIcon(activity.type)}></i>
            </div>
            
            <div className="activity-info">
              <div className="activity-description">
                {activity.description}
              </div>
              
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '0.5rem', 
                marginTop: '0.25rem'
              }}>
                <div className="activity-time">
                  {formatTimestamp(activity.timestamp)}
                </div>
                
                {activity.module && (
                  <>
                    <span style={{ color: 'var(--text-muted)' }}>•</span>
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '0.25rem',
                      fontSize: '0.7rem',
                      color: 'var(--text-muted)'
                    }}>
                      <i className={getModuleIcon(activity.module)}></i>
                      <span>{getModuleName(activity.module)}</span>
                    </div>
                  </>
                )}
              </div>
            </div>
            
            {activity.xp && activity.xp > 0 && (
              <div className="activity-value">
                +{activity.xp} XP
              </div>
            )}
          </div>
        ))}
      </div>

      {activities.length >= 10 && (
        <div style={{ 
          textAlign: 'center', 
          marginTop: '1rem',
          paddingTop: '1rem',
          borderTop: '1px solid var(--border-color)'
        }}>
          <button className="btn btn-outline-primary btn-sm">
            <i className="las la-external-link-alt me-1"></i>
            Ver Histórico Completo
          </button>
        </div>
      )}

      {/* Resumo de XP do dia */}
      {activities.length > 0 && (
        <div style={{ 
          marginTop: '1rem', 
          padding: '0.75rem', 
          background: 'var(--success-50)', 
          borderRadius: '8px',
          fontSize: '0.8rem',
          color: 'var(--success)'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            gap: '0.5rem',
            fontWeight: '600'
          }}>
            <i className="las la-chart-line"></i>
            <span>
              Total de XP hoje: {activities
                .filter(a => a.xp > 0)
                .reduce((sum, a) => sum + a.xp, 0)} XP
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecentActivityCard;